import { TreeSelect } from 'antd';
import type { TestsFilterProps } from '../reports.types';

const { SHOW_PARENT } = TreeSelect;

const TestsFilter = ({
  label,
  placeholder,
  categoriesWithMaterials,
  selectedValues,
  onChange,
}: TestsFilterProps) => {
  return (
    <>
      {label}:
      <TreeSelect
        style={{ marginTop: 7, width: '100%' }}
        treeCheckable={true}
        showCheckedStrategy={SHOW_PARENT}
        treeData={categoriesWithMaterials}
        placeholder={placeholder}
        value={selectedValues}
        onChange={onChange}
        showSearch
        treeNodeFilterProp="label"
      />
    </>
  );
};

export default TestsFilter;
